// sizes for inputs; relates to css selectors
export default {
	XSMALL: 'size-xsmall',
	SMALL: 'size-small',
	MEDIUM: 'size-medium',
	LARGE: 'size-large',
	XLARGE: 'size-xlarge',
	XXLARGE: 'size-xxlarge',
	FULL_WIDTH: 'size-full',

	// // possible future sizes
	// FINE: 'fine',
	// DIMINUTIVE: 'diminutive',
	// TINY: 'tiny',
	// SMALL: 'small',
	// MEDIUM: 'medium',
	// LARGE: 'large',
	// HUGE: 'huge',
	// GARGANTUAN: 'gargantuan',
	// COLOSSAL: 'colossal',
};